import React from "react";
import styled from "styled-components";
import Container from "../../components/Container";

export default function PageNotFound() {
   return (
      <Container>
         <View>
            <img src={require("../../assets/image/back_happy.png")} alt="back" />
            <Text>URL no encontrada</Text>
         </View>
      </Container>
   );
}

const View = styled.section`
   width: 100%;
   height: 100vh;
   display: flex;
   justify-content: center;
   align-items: center;
   background-size: cover;
   position: relative;
   background-color: rgba(25, 24, 24, 0.6);
   & img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: -2;
   }
`;
const Text = styled.p`
   font-size: 2em;
   font-weight: bold;
   position: relative;
   color: white;
`;
